"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalloutType = void 0;
var CalloutType;
(function (CalloutType) {
    CalloutType["success"] = "success";
    CalloutType["info"] = "info";
    CalloutType["warning"] = "warning";
    CalloutType["error"] = "error";
    CalloutType["note"] = "note";
    CalloutType["decision"] = "decision";
})(CalloutType || (exports.CalloutType = CalloutType = {}));
